import {skipToken} from '@reduxjs/toolkit/query';
import {BreadcrumbType, DataStatus} from 'platform/components';
import {match, Pattern} from 'ts-pattern';

import {useParams} from 'react-router-dom';

import {isNil, isNotNil} from 'ramda';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {useGetCampaignQuery} from '@dms/api/sales';
import {i18n} from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsSection, SettingsTemplate} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {CampaignForm} from './components/CampaignForm';

export function CampaignDetail() {
  const {id} = useParams();
  const navigate = useNavigate();

  const isCreating = isNil(id);

  const {data: campaign, isLoading, isError} = useGetCampaignQuery(isNotNil(id) ? {id} : skipToken);
  const {data: currentUser, isLoading: isCurrentUserLoading} = useGetCurrentUserInfoQuery(
    undefined,
    {skip: !isCreating}
  );

  const title = match({isCreating, name: campaign?.name})
    .with({isCreating: true}, () => i18n.t('entity.salesCampaign.actions.addCampaign'))
    .with({name: Pattern.string}, ({name}) => name)
    .otherwise(() => i18n.t('entity.salesCampaign.labels.title'));

  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.salesSettings.title'),
    },
    {
      label: i18n.t('entity.salesCampaign.labels.title'),
      href: settingsRoutes.campaigns,
    },
  ];

  return (
    <SettingsTemplate
      header={{title, breadcrumbs}}
      data-testid={testIds.settings.campaignEdit('page')}
      isLoading={isLoading}
      isError={isError}
    >
      <SettingsSection>
        <DataStatus isLoading={isCreating && isCurrentUserLoading}>
          <CampaignForm
            campaign={campaign}
            currentUserId={currentUser?.id}
            onDiscard={() => navigate(settingsRoutes.campaigns)}
            onSuccess={() => navigate(settingsRoutes.campaigns)}
            data-testid={testIds.settings.campaignEdit('form')}
          />
        </DataStatus>
      </SettingsSection>
    </SettingsTemplate>
  );
}
